// tippi/src/pages/carrier/Field.js
import React from 'react';
import { ui } from './carrierStyles';

// Etikett, kontroll og feilmelding. Kontrollen må ha id lik `id`.
export default function Field({ id, label, error, children, style }) {
  return (
    <div style={style}>
      <label htmlFor={id} style={ui.label}>{label}</label>
      {children}
      {error && <div role="alert" style={ui.fieldError}>{error}</div>}
    </div>
  );
}
